// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { SummaryQrCodeResponse } from "../schema";

export function serialize_SummaryQrCodeResponse_internal(value: SummaryQrCodeResponse): unknown {
  return ((value: { base64: string }): unknown => {
    return {
      base64: ((value: string): unknown => {
        return value;
      })(value["base64"]),
    };
  })(value);
}
export function serialize_SummaryQrCodeResponse(obj: SummaryQrCodeResponse): string {
  return renderJsonWithNumbersAsBigint(serialize_SummaryQrCodeResponse_internal(obj));
}
export function deserialize_SummaryQrCodeResponse_internal(value: unknown): ParserResult<SummaryQrCodeResponse> {
  return ((
    value: unknown,
  ): ParserResult<{
    base64: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeResponse]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeResponse]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "base64")) {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeResponse/base64]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'base64'.` };
    }
    const parsed_base64 = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryQrCodeResponse/base64]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["base64"]);
    })();
    if (!parsed_base64.success) {
      return { success: false, reason: parsed_base64.reason };
    }
    return { success: true, value: { base64: parsed_base64.value } };
  })(value);
}
export function deserialize_SummaryQrCodeResponse(str: string): ParserResult<SummaryQrCodeResponse> {
  return deserialize_SummaryQrCodeResponse_internal(parseJsonWithNumbersAsBigint(str));
}
